import { Skeleton } from "primereact/skeleton";
import Error from "../common/Error";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/redux";
import FilterCard from "./FilterCard";
import { ExamTypeResponse } from "../../models/dtos";
import { RootState } from "../../store";
import FilterBox from "./FilterBox";
import { examTypesApi } from "../../services/nomenclatures/examTypesApi";

type ExamTypesFilterProps = {
  getSelectedExamTypes: (state: RootState) => ExamTypeResponse[];
  setSelectedExamTypes: any;
};

const ExamTypesFilter = ({ getSelectedExamTypes, setSelectedExamTypes }: ExamTypesFilterProps) => {
  const selectedExamTypes = useSelector(getSelectedExamTypes);
  const dispatch = useAppDispatch();

  const { data: examTypes, error, isLoading } = examTypesApi.useGetExamTypesQuery();

  if (isLoading) return <Skeleton className="w-full h-2rem" />;
  if (error) return <Error error={error} />;

  return (
    <FilterCard title="По вид на изпит:">
      <FilterBox<ExamTypeResponse>
        filter
        value={selectedExamTypes}
        onChange={(e) => dispatch(setSelectedExamTypes(e.value))}
        options={examTypes?.data ?? []}
        optionLabel="name"
        listClassName="max-h-20rem"
        dataKey="examTypeId"
      />
    </FilterCard>
  );
};

export default ExamTypesFilter;
